import { Link } from "react-router-dom";
import { stats } from "@/mocks/leads";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20editorial%20scene%20with%20scattered%20documents%20folders%20and%20a%20magnifying%20glass%20on%20a%20wooden%20desk%2C%20dramatic%20warm%20amber%20side%20light%2C%20deep%20shadows%2C%20moody%20investigative%20atmosphere%2C%20high%20contrast%2C%20no%20text%2C%20artistic%20photography&width=1600&height=900&seq=kedou-hero-2026-a1&orientation=landscape"
        alt="蝌蚪爆料 线索核实工作场景"
        title="蝌蚪爆料 一手线索投稿平台"
        className="absolute inset-0 h-full w-full object-cover object-center opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/85 to-foreground-950/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/30" />

      <div className="relative mx-auto w-full max-w-[1280px] px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-2xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/50 bg-primary-500/15 px-3.5 py-1.5 text-xs font-medium text-primary-200">
            <i className="ri-record-circle-line text-primary-400" aria-hidden="true" />
            线索投稿 · 内幕对接 · 来源保护
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            把你看见的真相
            <br />
            交给一个会核实的地方
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-background-300 md:text-lg">
            蝌蚪爆料是一个专注线索征集的投稿平台。我们接收私信来源、内幕材料与真实经历，
            不追风、不编造，每一条线索都经过交叉核实后才对外呈现。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/guide#submit"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-2-line" aria-hidden="true" />
              进入投稿入口
            </Link>
            <Link
              to="/leads"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-400/40 bg-background-50/5 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/15"
            >
              <i className="ri-book-2-line" aria-hidden="true" />
              浏览已核实线索
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs text-background-300">
            <span className="flex items-center gap-2">
              <i className="ri-shield-user-line text-accent-400" aria-hidden="true" />
              投稿人默认匿名
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-lock-2-line text-accent-400" aria-hidden="true" />
              材料加密存储
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-article-line text-accent-400" aria-hidden="true" />
              48 小时内响应
            </span>
          </div>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-foreground-950/60 px-5 py-6 backdrop-blur">
              <dt className="text-xs text-background-400">{s.label}</dt>
              <dd className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {s.value}
                <span className="ml-1 text-sm font-normal text-background-400">{s.unit}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}